import React from 'react';

export default ({ color = '#FFFFFF', className = '' }) => (
  <svg
    className={className}
    width="20px"
    height="11px"
    viewBox="0 0 20 11"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>ic_attachment</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icons-Used" transform="translate(-21.000000, -364.000000)">
        <g id="ic_attachment-white" transform="translate(19.000000, 357.000000)">
          <g id="Icon-24px">
            <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
            <path
              d="M2,12.5 C2,9.46 4.46,7 7.5,7 L18,7 C20.21,7 22,8.79 22,11 C22,13.21 20.21,15 18,15 L9.5,15 C8.12,15 7,13.88 7,12.5 C7,11.12 8.12,10 9.5,10 L17,10 L17,12 L9.41,12 C8.86,12 8.86,13 9.41,13 L18,13 C19.1,13 20,12.1 20,11 C20,9.9 19.1,9 18,9 L7.5,9 C5.57,9 4,10.57 4,12.5 C4,14.43 5.57,16 7.5,16 L17,16 L17,18 L7.5,18 C4.46,18 2,15.54 2,12.5 L2,12.5 Z"
              id="Shape"
              fill={color}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
